import BrandLogo from "/static/images/tenants/samsung/samsung.png";
import { samsungContent } from "../brandContent/samsungBrandContent";
import { samsungPrize } from "../brandPrize/samsungPrize";
import { samsung } from "../brandThemes/samsung";

// Samsung Racing board (Assembly event). Structure is cloned from the Keychron
// time-trail layout but kept fully isolated: its own feature folder, theme and
// `gameStyle` so it can be restyled without touching any existing board.
//
// Data binding: the board loads Firestore/RTDB records by `tenantId` + `gameType`.
// By design it runs on the Elgiganten tenant (the kiosk auto-login user already
// exists there) and on Forza Motorsport data (`fm8`). Forza challenges are
// separated from Elgiganten's own F1 (`f12025`) / CS2 (`CSGO`) challenges purely
// by `gameType`, so don't run a second Elgiganten Forza challenge at the same
// time. To fully isolate later, swap to a real `samsung-XXXXX` tenant.
export const SAMSUNG_brandVariables = {
  tenantId: "elgiganten-nbxpa", // Elgiganten tenant (shared kiosk auto-login user)
  themeId: "samsung",
  gameStyle: "samsungracing",
  eventCode: "",
  gameType: "fm8", // Forza Motorsport — must match what the Samsung tracker writes
  brandLogoType: "element",
  brandLogo: BrandLogo,
  brandLogoSize: 400,
  theme: samsung,
  content: samsungContent,
  prize: samsungPrize,

  leaderboardLength: 10,
  disclaimer: null, // No prize confirmed yet — nothing to advertise
};
